import { onBeforeUnmount } from 'vue';
import { Capacitor } from '@capacitor/core';
import VueCookies from 'vue-cookies';

const TAB_SET_KEY = 'bn_open_tabs';
const TAB_ID_KEY = 'bn_tab_id';
const STALE_THRESHOLD_MS = 24 * 60 * 60 * 1000;

function getTabSet() {
    try {
        const raw = localStorage.getItem(TAB_SET_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        if (Array.isArray(parsed) || typeof parsed !== 'object' || parsed === null) return {};
        return parsed;
    } catch {
        return {};
    }
}

function saveTabSet(tabs) {
    localStorage.setItem(TAB_SET_KEY, JSON.stringify(tabs));
}

function addTab(id) {
    const tabs = getTabSet();
    tabs[id] = Date.now();
    saveTabSet(tabs);
}

function removeTab(id) {
    const tabs = getTabSet();
    delete tabs[id];
    saveTabSet(tabs);
    return Object.keys(tabs).length;
}

function pruneStale() {
    const tabs = getTabSet();
    const now = Date.now();
    let changed = false;
    for (const id of Object.keys(tabs)) {
        if (now - tabs[id] > STALE_THRESHOLD_MS) {
            delete tabs[id];
            changed = true;
        }
    }
    if (changed) saveTabSet(tabs);
}

export function useLogoutOnLastTabClose() {
    if (Capacitor.getPlatform() !== 'web') return;

    const tabId = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    sessionStorage.setItem(TAB_ID_KEY, tabId);

    pruneStale();
    addTab(tabId);

    const handlePageHide = () => {
        const remaining = removeTab(tabId);

        if (remaining === 0) {
            VueCookies.remove('bn_session_active');
        }
    };

    const handlePageShow = (event) => {
        if (event.persisted) {
            addTab(tabId);
        }
    };

    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('pageshow', handlePageShow);

    onBeforeUnmount(() => {
        window.removeEventListener('pagehide', handlePageHide);
        window.removeEventListener('pageshow', handlePageShow);
        removeTab(tabId);
    });
}
